module.exports = __webpack_public_path__ + "static/media/0322_IMG_LE_PLAFOND_CHROMATIC_CH2_1039.d19767b0.png";